/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Plan_Interval_Every_YearsInputs */

const en_plan_interval_every_years = /** @type {(inputs: Plan_Interval_Every_YearsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Every ${i?.count} years`)
};

const es_plan_interval_every_years = /** @type {(inputs: Plan_Interval_Every_YearsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Cada ${i?.count} años`)
};

/**
* | output |
* | --- |
* | "Every {count} years" |
*
* @param {Plan_Interval_Every_YearsInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const plan_interval_every_years = /** @type {((inputs: Plan_Interval_Every_YearsInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Interval_Every_YearsInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_plan_interval_every_years(inputs)
	return en_plan_interval_every_years(inputs)
});